module.exports = __webpack_public_path__ + "static/media/video-interior-1.3a619f0b.mp4";